// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"29":"28c48613","537":"2ca8797a","2043":"4c6bbecd","2997":"74e974ef","6827":"cb5bb49a","9653":"bfeaee2a"}[chunkId] + ".chunk.css";
};